import { Component, ViewChild, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/*Services*/
import { CachedDataService } from '@services/data/cached-data.service';
import { StateService } from '@services/state.service';
import { ShareDeviceService } from '@services';

/*Models */
import { User } from '@models/user';
import { Device } from '@models/device';
import { ObservableObject } from '@models/observable-object';
import { ShareRequest } from "@models";

import { environment } from '@environments';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit, OnDestroy {
  isAuth = false;
  isOpenMenu = false;
  user = new User;
  currentDevice: Device;
  currentObject;
  _environment = environment;
  currentObservableObject: ObservableObject;
  shareDeviceList: Array<ShareRequest>
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  @ViewChild('feedBackForm') feedBackForm;
  @ViewChild('settingsModal') settingsModal;
  @ViewChild('profileModal') profileModal;
  @ViewChild('shareDeviceConfirm') shareDeviceConfirm;
  @ViewChild('shareDeviceCancel') shareDeviceCancel;
  

  currentPage = '';
  ifActiveGeozone = false;

  constructor(
    private cachedDataService: CachedDataService,
    private router: Router,
    public stateService: StateService,
    private shareDeviceService: ShareDeviceService
  ) {
    this.isAuth = this.cachedDataService.isAuth();
    this.user = this.cachedDataService.getCurrentUser();
    this.currentDevice = this.stateService.currentDevice;

    cachedDataService.updateUserStatus.subscribe(() => {
      this.isAuth = this.cachedDataService.isAuth();
      this.user = this.cachedDataService.getCurrentUser();
    });
    this.stateService.observableObjectObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(object => {
        this.currentObservableObject = object;
      });
    this.shareDeviceService.updateRequestsObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(respone => {
        this.getShareDevice()
      });



    this.stateService.currentDeviceSubject
      .takeUntil(this.ngUnsubscribe)
      .subscribe(device => {

        this.currentDevice = device;
        if (device) {
          this.currentObject = this.cachedDataService.getCurrentObject();
          if(this.currentDevice.provider.toLowerCase() === "magicsystems" || this.currentDevice.provider.toLowerCase() === "pandora"){
            this.ifActiveGeozone = true;
          }else{
            this.ifActiveGeozone = false;
          }
        } else {
          this.ifActiveGeozone = false;
          this.currentObject = null;
        }
      });

    router.events.filter((event: any) => event instanceof NavigationEnd)
      .subscribe(event => {
        this.getShareDevice()
        this.isOpenMenu = false;
        if (event.url === '/online') {
          this.currentPage = 'online';
        } else if (event.url.indexOf('/personal') >= 0) {
          this.currentPage = 'personal';
        } else if (event.url.indexOf('/online') >= 0) {
          this.currentPage = 'detail';
        } else if (event.url.indexOf('/profile') >= 0) {
          this.currentPage = 'profile';
        } else if (event.url.indexOf('/share-requests') >= 0) {
          this.currentPage = 'share-requests';
        } else {
          this.currentPage = '';
        }
      });
  }
  ngOnInit(){
    this.getShareDevice()
  }

  showFeedbackForm() {
    // this.isOpenMenu = false;
    // this.feedBackForm.open();
  }

  logout() {
    this.cachedDataService.clearCache();
    this.router.navigate(['/signin']);
  }

  toggleMenu() {
    this.isOpenMenu = !this.isOpenMenu;
  }

  openSettings() {
    this.settingsModal.open();
  }
  openProfile() {
    this.profileModal.open();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getShareDevice(){
    if(!this.isAuth){
      return;
    }
    this.shareDeviceService.getShareDevice()
      .subscribe(response => {
        if(response && response.length){
          this.shareDeviceList = response.filter(item=>item.status.toLowerCase()=="sent")
        }else{
          this.shareDeviceList = null;
        }
      },
        error => {
          console.log(error);
        }
      );
  }

  openConfirmShare(request: ShareRequest){
    this.shareDeviceConfirm.open(request);
  }
  openCancelShare(request: ShareRequest){
    this.shareDeviceCancel.open(request);
  }

  
}



// WEBPACK FOOTER //
// ./src/app/view/header/header.component.ts